<template>
  <div class="ms-workbook">
    <div class="ms-workbook-content flex-column">
      <div class="workbook__toolbar" v-if="istoolbar">
        <toolbar-workbook
          @actionToolbar="setActionToolbar"
          :range-style="rangeStyle"
          :class="{'is-locked': isLockWorkbook}"
          :lockToolbar="isLockWorkbook"
          ref="toolbarWorkbook"
        ></toolbar-workbook>
      </div>
      <div class="workbook__body flex-column flex1">
        <div class="flex-row toolbar" v-show="isFormula">
          <div class="namebox">
            <div :id="idNameWorkbook" class="disable-style"></div>
            <div class="nameBox__disable" v-if="isLockWorkbook"></div>
          </div>
          <div
            class="workbook__textbox"
            v-show="isLockWorkbook"
            v-tooltip="'Chọn Sửa để thêm nội dung trên thuyết minh'"
          >
            <span class="icon icon16 only-view"></span> Chỉ xem
          </div>
          <div class="flex1 input-formular">
            <ms-input ref="formulaTextBox" left-icon="ic-excel formula-input" :hasBorder="false" />
            <div class="input-formular__disable" v-if="isLockWorkbook"></div>
          </div>
          <slot name="customWorkbook"></slot>
          <!-- <div class="ml-1 workbook__textbox">Số dự toán: =SUM(THANHTIEN)</div>
        <div class="mr-1 workbook__textbox">
          {{ $ms.format.formatAmount(263700000) }}
        </div>
        <ms-button class="workbook__textbox" :has-border="false" type="outline-button" left-icon="icon24 refresh-black"
          >Nạp</ms-button
        > -->
        </div>
        <div class="workbook__main flex1" id="workbook">
          <gc-spread-sheets
            @workbookInitialized="initSpread"
            @selectionChanged="selectionChanged"
            class="workbook-container"
          >
          </gc-spread-sheets>
          <FindReplaceDialog ref="findReplaceDialog" :spread="workbook" :isDialogVisible="isDialogVisibleFindReplace" />
        </div>
      </div>
      <div id="ss"></div>
    </div>

    <div class="workbook-overlay" v-show="overlay"></div>
  </div>
</template>

<script>
import '@grapecity/spread-sheets/styles/gc.spread.sheets.excel2016colorful.css';
import formHelper from '@/commons/workbook/explanationFormHelper';
import GC from '@grapecity/spread-sheets';
import {workbookHelper} from '@/commons/workbook/workbookHelper.js';
import {commandCustoms} from '@/commons/workbook/commandCustomWorkbook.js';
import {getCurrentInstance, ref, watch, onMounted, provide} from 'vue';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import i18n from '@/i18ns/i18n';

export default {
  name: 'MsWorkbook',
  props: {
    fileData: {
      default: null,
      type: [Object],
    },
    // Ẩn hiện conTextMenu
    allowConTextMenu: {
      default: true,
      type: [Boolean],
    },
    // Khóa mở Workbook
    isLockWorkbook: {
      default: false,
      type: [Boolean],
    },
    // Ẩn hiện toolbar
    istoolbar: {
      default: true,
      type: [Boolean],
    },
    itemContextMenuHide: {
      default: null,
      type: [Array],
    },
    isFormula: {
      default: true,
      type: [Boolean],
    },
    selectionChanged: {
      default: null,
      type: [Function],
    },
    contextMenu: {
      default: [],
      type: [Array],
    },
    isSetupPrintCol: {
      default: false,
      type: [Boolean],
    },
    isSetupPrintRow: {
      default: false,
      type: [Boolean],
    },
    isAddColumnDefault: {
      default: false,
      type: [Boolean],
    },
    isAddColumn: {
      default: false,
      type: [Boolean],
    },
    // Khi màn hình có 2 workbook lưu ý đặt 2 id khác nhau là được (trường hợp phổ biến popup)
    // id có thể giống nhau khi 2 workbook không cùng hiển thị trong DOM HTML
    idNameWorkbook: {
      default: 'nameBox',
      type: [String],
    },
    // Có dùng các tiện ích mở rộng không
    isExtensions: {
      default: false,
      type: [Boolean],
    },

    overlay: {
      default: false,
      type: [Boolean],
    },
  },
  emits: ['changeDataWorkbook', 'selectionChanged'],

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    const rangeStyle = ref({});
    const workbook = ref(null);
    const isDialogVisibleFindReplace = ref(false);
    provide('spread', workbook);
    provide('isDialogVisible', isDialogVisibleFindReplace);
    // context mặc định của hệ thống
    let contextMenuDatas = [...workbookHelper.ContextMenuExcelOption, ...props.contextMenu];
    let contextMenuExtensions = workbookHelper.contextMenuExtensions;
    const menuData = ref([]);

    var spreadValue = null;
    /**
     * Hàm thay đổi selections
     * TMNghia 31/04/2024
     */
    const selectionChanged = (e, args) => {
      //Gán style của range đang focus lên toolbar
      rangeStyle.value = workbookHelper.getActiveRangeStyle(workbook.value);
      emit('selectionChanged', e, args);
    };

    /**
     * Hàm xử lý sự kiện khi click toolbar
     */
    const setActionToolbar = action => {
      if (action.data.toolbar.nameCommmand == i18nEnum.actionToolbar.Search) {
        isDialogVisibleFindReplace.value = true;
        return;
      }
      formHelper.applyActionToolbar(workbook.value, action.data);
      //Gán style lên toolbar
      rangeStyle.value = workbookHelper.getActiveRangeStyle(workbook.value);
    };
    /**
     * Khởi tạo workbook designer
     */
    const initSpread = spread => {
      formHelper.registerCommandCustom(spread, commandCustoms);
      workbook.value = spread;
      workbook.value.options.newTabVisible = false;
      workbook.value.options.allowDragHeaderToMove = GC.Spread.Sheets.AllowDragHeaderToMove.row;
      spreadValue = spread;
      const culture = new GC.Spread.Common.CultureInfo();
      culture.NumberFormat.numberDecimalSeparator = ',';
      culture.NumberFormat.numberGroupSeparator = '.';
      culture.NumberFormat.arrayListSeparator = '\\';
      culture.NumberFormat.listSeparator = ';';
      culture.DateTimeFormat.shortDatePattern = 'dd/mm/yyyy';
      culture.LocalNumberFormat = {
        14: 'dd/mm/yyyy',
      };
      GC.Spread.Common.CultureManager.addCultureInfo('MISACulture', culture);
      GC.Spread.Common.CultureManager.culture('MISACulture');

      // kiểm tra sử dụng context menu không theo cấu hình
      workbook.value.options.allowContextMenu = props.allowConTextMenu;
      // gán lại context menu gốc để sau này thực hiện ẩn hiện các item của contextMenu
      // thực hiện ẩn các item của contextMenu
      initContextMenu();
      mapNameItemContextMenu();
      hideContextMenu();
      initWorkbookCustomName(i18nEnum.WorkbookDefaultNames);
      spread.contextMenu.onOpenMenu = function (menuData, itemsDataForShown, hitInfo, spread) {
        formHelper.customBeforeShowContextMenu(menuData, itemsDataForShown, hitInfo, spread);
      };

      // emit dữ liệu workbook mỗi khi có sự thay đổi
      emit('changeDataWorkbook', workbook.value);
      let nameBox = new GC.Spread.Sheets.NameBox.NameBox(props.idNameWorkbook, spread);

      //khai báo sự kiện ctrl+f để không bị trình duyệt đè mặc định
      spread.commandManager().setShortcutKey('openDialogFindAndReplace', 70, true, false, false, false);

      formHelper.changeStatusLockWorkbook(props.isLockWorkbook, workbook.value);
    };

    // Thêm context menu mới từ props
    watch(
      () => props.contextMenu,
      newValue => {
        contextMenuDatas = [...workbookHelper.ContextMenuExcelOption, ...newValue];
        initContextMenu();
        mapNameItemContextMenu();
        hideContextMenu();
      },
    );

    /**
     * hàm thực hiện add sheet
     */
    const addSheetWb = index => {
      if (spreadValue) {
        spreadValue.addSheet(index);
      }
    };

    const fromJsonWb = (dataJson) => {
      if (spreadValue) {
        spreadValue.fromJSON(dataJson);
      }
    };
    /**
     * custom context menu
     */
    const initContextMenu = () => {
      let wb = workbook.value;
      let wbMenuData = (wb.contextMenu.menuData = []);

      if (props.isExtensions) {
        contextMenuDatas = [...contextMenuDatas, ...contextMenuExtensions];
      }
      //Push các context item để đăng ký sự kiện
      for (var i = 0; i < contextMenuDatas.length; i++) {
        wbMenuData.push(contextMenuDatas[i]);
      }
      menuData.value = wbMenuData;
    };
    /**
     * hàm thực hiện import file
     */
    const importFile = (file, successFn, errorFn, fileType) => {
      if (spreadValue) {
        if (!file) {
          return;
        }
        spreadValue.import(
          file,
          function () {
            if (successFn && typeof successFn === 'function') {
              successFn();
            }
          },
          function () {
            if (errorFn && typeof errorFn === 'function') {
              errorFn();
            }
          },
          fileType || GC.Spread.Sheets.FileType.excel,
        );
      }
    };
    /**
     * Thêm customnName vào workbook
     */
    const initWorkbookCustomName = customNames => {
      let wb = workbook.value;

      if (!customNames || customNames.length == 0) {
        return;
      }

      customNames.forEach(name => {
        if (!name) {
          return;
        }

        let key = name.FieldCode,
          value = name.Value;

        if (!key || wb.getCustomName(key)) {
          return;
        }

        if (Number(value)) {
          value = `=${value}`;
        } else {
          value = `="${value}"`;
        }
        wb.addCustomName(key, value, null, null);
      });
    };

    /**
     * Thêm customnName vào worksheet
     */
    const initWorksheetCustomName = (customNames, sheetName) => {
      let wb = workbook.value,
        sheet = wb.getSheetFromName(sheetName);

      if (!customNames || customNames.length == 0 || sheet == null) {
        return;
      }

      customNames.forEach(name => {
        if (!name) {
          return;
        }

        let key = name.FieldCode,
          value = name.Value;

        if (!key || wb.getCustomName(key) || sheet.getCustomName(key)) {
          return;
        }

        if (Number(value)) {
          value = `=${value}`;
        } else {
          value = `="${value}"`;
        }
        sheet.addCustomName(key, value, null, null);
      });
    };

    /**
     * Ẩn các action trên context menu nếu cần
     */
    const hideContextMenu = () => {
      if (!workbook.value) {
        return;
      }
      if (props.isAddColumn) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj =>
            obj.id !== i18nEnum.idCommandContextMenu.InsertRowCustom ||
            obj.id !== i18nEnum.idCommandContextMenu.InsertRow,
        );
      }
      workbook.value.contextMenu.menuData = menuData.value;
      if (props.isAddColumnDefault) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj => obj.id !== i18nEnum.idCommandContextMenu.InsertColumnCustom,
        );
      } else {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj => obj.id !== i18nEnum.idCommandContextMenu.InsertColumnDetail,
        );
      }
      if (!props.isSetupPrintCol && props.isSetupPrintRow) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj => obj.type !== i18nEnum.TypeContextMenuWorkbook.SetupPrintCol,
        );
      }
      if (props.isSetupPrintCol && !props.isSetupPrintRow) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj => obj.type !== i18nEnum.TypeContextMenuWorkbook.SetupPrintRow,
        );
      }
      if (!props.isSetupPrintCol && !props.isSetupPrintRow) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj =>
            obj.type !== i18nEnum.TypeContextMenuWorkbook.SetupPrintCol &&
            obj.type !== i18nEnum.TypeContextMenuWorkbook.SetupPrintRow &&
            obj.type !== i18nEnum.TypeContextMenuWorkbook.SetupPrint,
        );
      }
      if (!props.itemContextMenuHide || props.itemContextMenuHide.length == 0) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj => obj.id !== i18nEnum.idCommandContextMenu.InsertRowCustom,
        );
        return;
      }
      // thực hiện xóa các item action menu cần ẩn
      props.itemContextMenuHide.forEach(element => {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(obj => obj.id !== element);
      });
      if (props.isAddColumn) {
        workbook.value.contextMenu.menuData = workbook.value.contextMenu.menuData.filter(
          obj =>
            obj.id !== i18nEnum.idCommandContextMenu.InsertRowCustom &&
            obj.id !== i18nEnum.idCommandContextMenu.InsertRow,
        );
      }
    };
    // gán tên tiếng việt cho phần tử của  context menu
    const mapNameItemContextMenu = () => {
      let contextmenu = workbook.value.contextMenu.menuData;
      contextmenu.forEach((item, index) => {
        item.text = contextMenuDatas[index].title;
      });
    };

    onMounted(() => {
      // Ẩn các tab trên
      proxy.$nextTick(() => {
        let el = proxy.$refs.formulaTextBox?.input;
        if (!el || !workbook.value) return;

        let fbx = new GC.Spread.Sheets.FormulaTextBox.FormulaTextBox(el);
        fbx.workbook(workbook.value);
        let nameBox = new GC.Spread.Sheets.NameBox.NameBox(
          document.getElementById(props.idNameWorkbook),
          workbook.value,
        );

        //Gán style của range đang focus lên toolbar
        rangeStyle.value = workbookHelper.getActiveRangeStyle(workbook.value);
      });
    });

    watch(
      () => props.isLockWorkbook,
      newValue => {
        if (!workbook.value) {
          return;
        }
        // nếu khóa workbook clear undo redo để sau này phục vụ cho việc checkchange
        workbook.value.undoManager().clear();
        formHelper.changeStatusLockWorkbook(newValue, workbook.value);
      },
    );

    watch(
      () => props.allowConTextMenu,
      newValue => {
        workbook.value.options.allowContextMenu = newValue;
      },
    );

    watch(
      () => props.itemContextMenuHide,
      newValue => {
        hideContextMenu();
      },
    );
    watch(
      () => props.idNameWorkbook,
      newValue => {
        let nameBox = new GC.Spread.Sheets.NameBox.NameBox(document.getElementById(newValue), workbook.value);
      },
    );

    return {
      rangeStyle,
      workbook,
      menuData,
      selectionChanged,
      setActionToolbar,
      initSpread,
      initContextMenu,
      hideContextMenu,
      addSheetWb,
      fromJsonWb,
      importFile,
      isDialogVisibleFindReplace,
      initWorkbookCustomName,
      initWorksheetCustomName,
    };
  },
};
</script>

<style lang="scss" scoped>
.ms-workbook {
  height: 100%;
  .ms-workbook-content {
    height: 100%;

    .workbook__toolbar {
      z-index: 1;
      background-color: $white;
      position: relative;
    }
    .workbook__body {
      .toolbar {
        border-top: 1px solid #d4d7de;
        border-bottom: 1px solid #d4d7de;
        height: 32px;
      }
      .workbook__textbox {
        display: flex;
        align-items: center;
        height: 32px;
        padding: 0 16px;
        cursor: pointer;
        border-right: 1px solid #d4d7de;
        background: rgba(157, 153, 153, 0.155);
        .icon-btn {
          display: flex;
          align-items: center;
          border: none;
          cursor: pointer;
          background: unset;
        }
      }
      .namebox {
        position: relative;
        .nameBox__disable {
          background: rgba(157, 153, 153, 0.155);
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
      .namebox div:first-child {
        width: 90px;
        height: 100%;
      }

      .input-formular {
        border-right: 1px solid #d4d7de;
        display: flex;
        align-items: center;
        position: relative;
        .input-formular__disable {
          background: rgba(157, 153, 153, 0.155);
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
      .mw-150 {
        max-width: 150px;
      }
      .workbook__main {
        position: relative;
        .workbook-container {
          height: 100%;
        }
      }
    }

    .is-locked {
      pointer-events: none;
    }
  }

  .workbook-overlay {
    z-index: 1;
    height: 100%;
    width: 100%;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
<style lang="scss">
.ms-workbook {
  div[gcuielement='gcDropDownWindow'] {
    max-width: 500px !important;
    max-height: 215px !important;
    overflow-y: auto !important;
  }
}
</style>
